module.exports = __webpack_public_path__ + "img/Number.9e2349eb.svg";